import React from 'react';
import axios from 'axios';
import { withStyles } from '@material-ui/styles';
import { IconButton, InputBase, Typography } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import OpenInNewRoundedIcon from '@material-ui/icons/OpenInNewRounded';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';


const useStyles = (theme) => ({
  searchForm: {
    display: 'block', 
    position: 'relative', 
    width: 400,
    margin: '0 auto 8px auto',
    '@media (max-width:599px)': {
      width: '100%',
      minWidth: 270
    }
  },
  inputBase: {
    height: '38px',
    width: '100%',
    // visibility: 'hidden',
    borderRadius: '19px',
    fontSize: '14px',
    backgroundColor: 'rgba(22, 22, 22, 1)',
    color: theme.palette.text.secondary,
    paddingRight: '26px',
    '&:hover': {
      backgroundColor: 'rgba(12, 12, 12, 1)'
    },
    '& .MuiInputBase-input': {
      padding: '12px',
      height: '100%'
    },
  },
  searchIcon: {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    position: 'absolute', 
    right: 0, 
    top: 0,
    height: '100%', 
    width: '38px', 
    borderRadius: '19px',
    cursor: 'pointer',
    backgroundColor: 'rgba(22, 22, 22, 1)',
    '&:hover': {
      backgroundColor: 'rgba(12, 12, 12, 1)'
    }
  },
  container: {
    display: 'flex',
    width: '100%',
    minWidth: 270,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  card: {
    overflow: 'hidden',
    position: 'relative',
    height: 420,
    width: 270,
    minWidth: 270, 
    // flexGrow: 1,
    margin: 16,
    boxShadow: theme.shadows[7],
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent'
    },  
    '& .button': {
      position: 'absolute',
      right: 0,
      bottom: 0,
      zIndex: 3,
      padding: 16,
      color: 'rgb(200, 200, 200)'
      // borderRadius: 0,
      // marginTop: 8
    },
    '& .poster': {
      position: 'relative', 
      overflow: 'hidden', 
      height: '100%', 
      width: '100%',
    },
    '& .details': {
      position: 'absolute',
      padding: 20,
      bottom: '-87px',
      // bottom: 0,
      left: 0,
      zIndex: 2,
      transition: 'all 0.5s ease',
      width: '100%',
      height: '52%',
      '& .MuiRating-sizeSmall': {
        fontSize: '1.225rem'
      },
      '& .tags': {
        position: 'relative',
        marginTop: 8,
        marginBottom: 24,
        '& span': {
          padding: '2px 5px',
          borderRadius: 2,
          marginRight: 4,
          color: 'rgba(20, 20, 20, 0.975)',
          fontWeight: 500,
          backgroundColor: 'rgb(163, 102, 255)',
          boxShadow: theme.shadows[3],
        }
      },
      // '& .description': {
      //   paddingTop: 24,  
      // },
    },
    '&:hover .details, &:hover .poster:before': {
      bottom: 0,
    },
    '&:hover .img': {
      filter: 'blur(3px)',
    },
    '&:hover div.tags': {
      marginBottom: 8,
    }
  },
  
});


class MoviesComponent extends React.Component { 
	constructor(props) {
    super(props);
    this.state = {
      movies: [],
      searchValue: '',
    }
    this.handleDetail = this.handleDetail.bind(this)
    this.truncateString = this.truncateString.bind(this)
    this.submitSearch= this.submitSearch.bind(this)
    this.searchChange = this.searchChange.bind(this)
  }

  componentDidMount() {
    axios.get(`https://backendexample.sanbersy.com/api/data-movie`).then(res => {
      let result = res.data.map(el => {
        if (Boolean(el.title) === false) el.title = " ";
        if (Boolean(el.image_url) === false) el.image_url = " ";
        if (Boolean(el.genre) === false) el.genre = " ";
        if (Boolean(el.rating) === false) el.rating = 0;
        if (Boolean(el.year) === false) el.year = 0;
        if (Boolean(el.duration) === false) el.duration = 0;
        if (Boolean(el.description) === false) el.description = " ";
        if (Boolean(el.review) === false) el.review = " ";
        let title = el.title.charAt(0).toUpperCase() + el.title.slice(1)
        let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
        let description = el.description.charAt(0).toUpperCase() + el.description.slice(1)
        let review = el.review.charAt(0).toUpperCase() + el.review.slice(1)
        const { id, image_url, rating, year, duration } = el;
        return { id, title, image_url, genre, rating, year, duration, description, review }; 
      })
      this.setState({movies: result}); 
    });
  }

  submitSearch(e) {
    e.preventDefault();
    
    axios.get(`https://backendexample.sanbersy.com/api/data-movie`).then((res) => {
      let result = res.data.map(el => {
        if (Boolean(el.title) === false) el.title = " ";
        if (Boolean(el.image_url) === false) el.image_url = " ";
        if (Boolean(el.genre) === false) el.genre = " ";
        if (Boolean(el.rating) === false) el.rating = 0;
        if (Boolean(el.year) === false) el.year = 0;
        if (Boolean(el.duration) === false) el.duration = 0;
        if (Boolean(el.description) === false) el.description = " ";
        if (Boolean(el.review) === false) el.review = " ";
        let title = el.title.charAt(0).toUpperCase() + el.title.slice(1)
        let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
        let description = el.description.charAt(0).toUpperCase() + el.description.slice(1)
        let review = el.review.charAt(0).toUpperCase() + el.review.slice(1)
        const { id, image_url, rating, year, duration } = el;
        return { id, title, image_url, genre, rating, year, duration, description, review }; 
      })
        
      let filteredTitle = result.filter(movie => movie.title.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !== -1);
      let filteredGenre = result.filter(movie => movie.genre.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !== -1);
      let filteredRating = result.filter(movie => movie.rating.toString() === this.state.searchValue.toString())
      let filteredYear = result.filter(movie => movie.year.toString().indexOf(this.state.searchValue.toString()) !== -1);
      let filteredDuration = result.filter(movie => movie.duration.toString().indexOf(this.state.searchValue.toString()) !== -1);
      let filteredDescription = result.filter(movie => movie.description.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !== -1);
      let filteredReview = result.filter(movie => movie.review.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !== -1);
      let newMovies = [...filteredTitle, ...filteredGenre, ...filteredRating, ...filteredYear, ...filteredDuration, ...filteredDescription,  ...filteredReview];
      this.setState({movies: [...new Set(newMovies)], input: '' });
    })
  }

  searchChange(e) {
    this.setState({searchValue: e.target.value});
  }

  truncateString(str, num) {
    if (str === null) return '';
    if (str.length <= num) return str;
    return str.slice(0, num) + '...';
  }

  handleDetail(event) {
    let detailId = event.currentTarget.value;
    this.props.history.push(`/movie/detail/${detailId}`)
  }

  render() {
    const { classes } = this.props;
    return(
      <>
        <form onSubmit={this.submitSearch} className={classes.searchForm}>
          <InputBase 
            type="text" 
            title="search by name, genre, release, platform and mode" 
            placeholder="Type anything..." 
            title="Search"
            value={this.state.searchValue} 
            onChange={this.searchChange} 
            className={classes.inputBase} 
          />
          <IconButton 
            onClick={this.submitSearch}
            disableFocusRipple
            disableRipple
            className={classes.searchIcon}  
          >
            <SearchRoundedIcon />
          </IconButton>
        </form>
        <div className={classes.container}>
          {
            this.state.movies.map((item) => {
              return(
                <div key={item.title} className={classes.card}>
                  <IconButton className="button" onClick={this.handleDetail} value={item.id}>
                    <OpenInNewRoundedIcon fontSize="small" /> 
                  </IconButton>
                  <div className="poster">
                    <div 
                      className='img' 
                      style={{
                        height: '100%', 
                        transition: 'all 0.5s ease', 
                        background: `url(${item.image_url}) center/auto 100% no-repeat rgba(10, 10, 10, 0.975)`, 
                        border: '2px solid rgba(12, 12, 12, 0.975)',
                        // border: '2px solid rgba(26, 26, 26, 0.975)',
                        // border: '1px solid rgb(163, 102, 255)'
                    }} />
                  </div>  
                  <div className="details">
                    <Typography variant="h2" style={{textTransform: 'capitalize', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 22, verticalAlign: 'middle', fontWeight: 500}}>{item.title}</Typography>
                    <span style={{color: 'rgb(144, 144, 144)', fontSize: 14, lineHeight: 'normal', marginRight: 4}}>{item.year},</span> 
                    <span style={{color: 'rgb(144, 144, 144)', fontSize: 14, lineHeight: 'normal'}}>{(item.duration/60).toString().split('.')[0]}hr {item.duration == 0 ? null : item.duration % 60}min </span>
                    <div style={{display: 'flex', fontSize: 15, alignItems: 'center', marginLeft: '-4px'}}>
                      <Rating name="rating" value={item.rating/2} precision={0.5} readOnly size="small" style={{marginRight: 8}}/>
                      <span style={{color: 'rgb(144, 144, 144)', fontSize: 14, lineHeight: 'normal'}}>{item.rating}/10</span>
                    </div>
                    <div className="tags">
                      {item.genre.includes(',') 
                        ? <span>{this.truncateString(item.genre.split(',')[0].trim().charAt(0).toUpperCase() + item.genre.split(',')[0].trim().slice(1), 14)}</span> 
                        : <span>{this.truncateString(item.genre.trim().charAt(0).toUpperCase() + item.genre.trim().slice(1), 25)}</span>
                      } 
                      {item.genre.split(',')[1]
                        ? <span>{this.truncateString(item.genre.split(',')[1].trim().charAt(0).toUpperCase() + item.genre.split(',')[1].trim().slice(1), 14)}</span> 
                        : <></>
                      } 
                    </div>
                    <div 
                      className="description"
                      style={{
                        // height: 250,
                        // whiteSpace: 'wrap', 
                        // overflow: 'hidden',
                        // textOverflow: 'ellipsis'
                      }}
                    >
                      {this.truncateString(item.description, 100)}
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </>
    )
  }
}

export default withStyles(useStyles)(MoviesComponent);
 